'use strict';

bbw.filter.url = ['$rootScope', function($rootScope) {
    return function(key) {
        if (angular.isObject(key) && '$' in key) {
            key = key[(arguments[1] || {})[key['$']]];
        }
        var tpl = $rootScope.bbwUrls[key];
        return tpl ? ngtk.tools.string.parseTemplate(tpl, arguments[1] || {}, '#') : '';
    }
}];
